export const RESET_CHANGE_SITUATION = "RESET_CHANGE_SITUATION";
export const SET_CHANGE_SITUATION_DATA = "SET_CHANGE_SITUATION_DATA";
